<template>
  <section class="ws-cis-credentials">
    <p class="ws-cis-credentials-warning">
      <strong>Внимание!</strong> Доступы до CIS видны только 1 раз. Скопируйте их к себе.
      На всякий случай, мы их отправили вам на e-mail.
    </p>

    <p class="ws-cis-credentials-pair">
      <strong>Логин: </strong>{{ login }}<br>
      <strong>Пароль: </strong>{{ password }}
    </p>

    <b-tooltip :label="$t('Скопировать пару логин-пароль в буфер обмена')" type="is-dark">
      <a href="" @click.prevent="copyInfoToClipboard">
        Скопировать
        <ws-icon
          class="ws-button__icon"
          name="copy"
          color="#1c3b8d"
          width="16"
          height="24"
        />
      </a>
    </b-tooltip>
  </section>
</template>

<script>
import clipboardMixin from '@/mixins/clipboard.mixin'

export default {
  name: 'WsCisCredentials',
  mixins: [clipboardMixin],
  props: {
    url: {
      type: String,
      default () {
        return undefined
      }
    },
    login: {
      type: String,
      default () {
        return undefined
      }
    },
    password: {
      type: String,
      default () {
        return undefined
      }
    }
  },
  methods: {
    copyInfoToClipboard () {
      const data = `CIS URL: ${this.url} \n\nЛогин: ${this.login} \nПароль: ${this.password}`
      this.copyToClipboard(data)

      this.$buefy.toast.open({
        message: `Информация успешно скопирована`,
        type: 'is-success'
      })
    }
  }
}
</script>
